import React from 'react'

type BaseButtonProps = {
  className?: string
}
type ButtonButtonProps = BaseButtonProps &
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>

export type ButtonProps = ButtonButtonProps

export const PillButton = ({ children, className, ...props }: ButtonProps): React.ReactElement => {
  return (
    <button className={`border-outline px-xs relative rounded-full border text-center ${className}`} {...props}>
      {children}
    </button>
  )
}
